// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35HsG","label":"styles_label__1chtD"};